import { Component, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout'; // Import BreakpointObserver and Breakpoints
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AngularMaterialModule } from '../../../material.module';
import { tenantSettings, ThemeService } from 'src/theme';

@Component({
    standalone: true,
    imports: [CommonModule, RouterModule, AngularMaterialModule],
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent {
    @Output() collapseStatusChange: EventEmitter<{ isCollapseNav: boolean; isMobile: boolean }> = new EventEmitter<{ isCollapseNav: boolean; isMobile: boolean }>();
    isCollapseNav = false;
    panelOpenState = false;
    menuItems: any;
    lowerMenuItems: any;
    isMobile = false;
    logo: string;
    isSubAgent = localStorage.getItem('isSubAgent');
    protected isRiyadTenant: boolean;

    constructor(private eRef: ElementRef, private breakpointObserver: BreakpointObserver, private readonly themeService: ThemeService) {
        this.getLogo();
        const tenantKey = localStorage.getItem('tenantKey') || '';
        const riyadTenant = tenantSettings.find((tenant) => tenant.name.toLowerCase() === 'riyad');
        this.isRiyadTenant = tenantKey === riyadTenant?.key;

        this.breakpointObserver.observe(['(max-width: 767px)']).subscribe((result) => {
            this.isMobile = result.matches;
            if (this.isMobile) {
                this.collapseNav();
            } else {
                this.unCollapseNav();
            }
        });

        this.menuItems = themeService.getActiveThemeAssets('sideMenu');
        this.lowerMenuItems = themeService.getActiveThemeAssets('sideMenuSecondaryItems');
    }

    private getLogo() {
        this.logo = this.themeService.getActiveThemeAssets('logoSvg');
    }

    collapseNav() {
        this.isCollapseNav = true;
        this.collapseStatusChange.emit({ isCollapseNav: this.isCollapseNav, isMobile: this.isMobile });
    }

    unCollapseNav() {
        this.isCollapseNav = false;
        this.collapseStatusChange.emit({ isCollapseNav: this.isCollapseNav, isMobile: this.isMobile });
    }

    toggleCollapseNav() {
        // if (this.isMobile) return;
        this.isCollapseNav = !this.isCollapseNav;
        this.collapseStatusChange.emit({ isCollapseNav: this.isCollapseNav, isMobile: this.isMobile });
    }
    onMenuItemClick(): void {
        if (!this.isMobile) return;
        this.isCollapseNav = true;
    }
    @HostListener('document:click', ['$event'])
    handleClickOutside(event: Event) {
        if (!this.isMobile) return;
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.isCollapseNav = true;
        }
    }
}
